import { useCallback, useRef, useState } from "react"

const DURATION = 3200

const useToasts = () => {
  const [toasts, setToasts] = useState([])
  const counter = useRef(0)

  const dismiss = useCallback(id => setToasts(list => list.filter(toast => toast.id !== id)), [])

  const notify = useCallback((message, tone = "success") => {
    const id = ++counter.current
    setToasts(list => [...list.slice(-2), { id, message, tone }])
    const duration = tone === "tip" ? DURATION * 2.5 : tone === "error" ? DURATION * 1.6 : DURATION
    setTimeout(() => dismiss(id), duration)
  }, [dismiss])

  return { toasts, notify, dismiss }
}

export default useToasts
